module.exports = __webpack_public_path__ + "images/assets/c2854e69a67abededb09fcbe3663bc54.svg";